<template>
  <div>
    <div
      class="h-100 position-absolute"
      id="roam_path"
      :class="setSemitransparent ? 'semitransparent' : ''"
      v-drag
    >
      <el-row class="path_header">
        <el-col :span="12">
          <span>路径列表</span>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" size="mini" @click="addPath" class="r">增加路径</el-button>
        </el-col>
      </el-row>
      <!-- 路径列表 -->
      <div class="m-t-10 path_table">
        <el-table :data="pathData" class="w-100" height="100%" @cell-click="cellClick">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="路径名称" width="80"></el-table-column>
          <el-table-column prop="speed" label="播放速度" width="80"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip placement="top" content="播放" :open-delay="1000">
                <el-button
                  type="success"
                  icon="el-icon-caret-right"
                  @click="getRoamPathDetail(scope.row.id)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="编辑" :open-delay="1000">
                <el-button
                  type="primary"
                  icon="iconfont icon-edit"
                  @click="modifyPath(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip placement="top" content="删除" :open-delay="1000">
                <el-button
                  type="danger"
                  icon="iconfont icon-close"
                  @click="deletePath(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="m-t-10 r">
        <el-pagination
          background
          @current-change="getRoamTraceList"
          :current-page.sync="page.pageNo"
          :page-size="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.pageTotal"
        ></el-pagination>
      </div>
    </div>
    <div
      class="h-100 position-absolute"
      id="roam_point"
      v-if="showPoint"
      :class="setSemitransparent ? 'semitransparent' : ''"
      v-drag
    >
      <!-- <div class="close-btn"></div> -->
      <el-row class="m-10">
        <el-col :span="12">
          <span>路径点列表</span>
        </el-col>
        <el-col :span="12">
          <i @click="closePoint" class="cur_pointer iconfont icon-close r"></i>
        </el-col>
      </el-row>
      <!-- 点列表 -->
      <el-table
        ref="pointTable"
        :data="currentParamList"
        stripe
        class="w-100"
        height="300px"
        @cell-click="pointCell"
      >
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="eye" label="路径点坐标" width="170">
          <template #default="{row}">
            <span>{{ row.eye.join(', ') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top" content="修改" :open-delay="1000">
              <el-button
                type="primary"
                icon="iconfont icon-edit"
                @click="modifyPoint(scope.$index, currentParamList)"
              ></el-button>
            </el-tooltip>
            <el-tooltip placement="top" content="删除" :open-delay="1000">
              <el-button
                type="danger"
                icon="iconfont icon-close"
                @click="deletePoint(scope.$index, currentParamList)"
              ></el-button>
            </el-tooltip>
            <el-tooltip placement="top" content="向下插入一行" :open-delay="1000">
              <el-button
                type="primary"
                icon="iconfont icon-add"
                @click="insertPoint(scope.$index, currentParamList)"
              ></el-button>
            </el-tooltip>
            <el-tooltip placement="top" content="上移" :open-delay="1000">
              <el-button
                v-if="scope.$index !== 0"
                type="primary"
                icon="iconfont icon-up"
                @click="adjustPoint(scope.$index, scope.$index - 1, currentParamList)"
              ></el-button>
            </el-tooltip>
            <el-tooltip placement="top" content="下移" :open-delay="1000">
              <el-button
                v-if="scope.$index < currentParamList.length - 1"
                type="primary"
                icon="iconfont icon-down"
                @click="adjustPoint(scope.$index, scope.$index + 1, currentParamList)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="point_bottom m-t-10">
        <el-button type="success" size="mini" @click="startPlay(currentParamList)">预览</el-button>
        <el-button type="primary" size="mini" @click="addPoint">增加路径点</el-button>
        <el-button type="primary" size="mini" @click="savePoint(currentParamList)">保存</el-button>
      </div>
    </div>
    <!-- 路径新增编辑弹框 -->
    <el-dialog
      :title="pathTitle"
      :visible.sync="pathFormVisible"
      width="30%"
      @close="cancelPath"
      :close-on-click-modal="false"
    >
      <el-form :model="pathForm">
        <el-form-item label="路径名称" label-width="120px">
          <el-input v-model="pathForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="播放速度" label-width="120px">
          <el-input v-model="pathForm.speed" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPath">取 消</el-button>
        <el-button type="primary" @click="submitPathForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import roamTrace from '@/services/roamTrace'

export default {
  data() {
    return {
      currentParamList: [],
      currentParam: {
        eye: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      showPoint: false,
      pathData: [],
      pathFormVisible: false,
      pathTitle: '',
      currentTraceId: '',
      pathForm: {
        siteId: '',
        code: '',
        name: '',
        speed: '',
      },
      keyWord: '',
      speed: 40,
    }
  },
  props: ['setSemitransparent'],
  created() {
    this.getRoamTraceList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    // 点击播放
    async getRoamPathDetail(id) {
      this.currentTraceId = id
      await this.getRoamTraceDetail()
      console.log(this.currentParamList, 111)
      await this.startPlay(this.currentParamList)
    },
    async getRoamTraceList() {
      const query = {
        pagesize: this.page.pageSize,
        pageno: this.page.pageNo,
        name: this.keyWord,
      }
      const res = await roamTrace.getRoamTraceList(query)
      if (res && res.code === 0 && res.data) {
        this.pathData = res.data
        this.page.pageTotal = res.page.recordCount
      }
    },
    // 获取当前相机参数
    async addPoint() {
      await this.getCameraInfo()
      this.currentParamList.push({
        detail: this.currentParam,
        eye: this.currentParam.eye,
      })
    },
    async getCameraInfo() {
      this.currentParam = await PlayerUtils.call(window.player.Native.CameraAnimation.cameraParam)
    },
    /**
     * 通过速度求出点与点之间所需要的时间
     *  */
    getPointTime(start, end, speed) {
      const distance = Math.sqrt(
        Math.pow(start[0] - end[0], 2) +
          Math.pow(start[1] - end[1], 2) +
          Math.pow(start[2] - end[2], 2)
      )
      return distance / speed
    },
    // 添加关键帧
    async addKeyFrames(currentParam) {
      if (!_.isArray(currentParam)) {
        this.currentParamList.push({
          detail: this.currentParam,
          eye: this.currentParam.eye,
        })
      }
      const bool = await PlayerUtils.call(
        window.player.Native.CameraAnimation.addKeyFrames,
        this.currentParamList
      )
      this.currentParam = null
    },
    // 预览
    async startPlay(list) {
      const keyFramesList = []
      await PlayerUtils.call(window.player.Native.CameraAnimation.clearKeyFrame)
      // 计算关键点所处的时间
      _.forEach(list, (el, index) => {
        if (index !== 0) {
          const time = this.getPointTime(list[index - 1].detail.eye, el.detail.eye, this.speed)
          el.detail.time = time + list[index - 1].detail.time
        } else {
          el.detail.time = 0
        }
        keyFramesList.push(el.detail)
      })
      const bool = await PlayerUtils.call(
        window.player.Native.CameraAnimation.addKeyFrames,
        keyFramesList
      )
      if (bool) {
        window.player.Native.CameraAnimation.start()
      }
    },
    // 点击路径列表
    cellClick(row, column, cell, event) {
      if (column.label !== '操作') {
        this.currentTraceId = row.id
        this.showPoint = true
        this.getRoamTraceDetail()
      }
    },
    // 关闭路径点列表
    closePoint() {
      this.showPoint = false
      this.currentParamList = []
    },
    // 关闭弹窗
    cancelPath() {
      this.pathForm = this.$options.data().pathForm
      this.pathFormVisible = false
    },
    //
    addPath() {
      this.pathFormVisible = true
      this.pathTitle = '新增路径'
    },
    //
    modifyPath(row) {
      this.pathFormVisible = true
      this.pathTitle = '编辑路径'
      this.pathForm = _.cloneDeep(row)
    },
    // 删除路径
    deletePath(row) {
      this.$confirm('是否确定删除当前路径?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await roamTrace.delRoamTrace([row.id])
        if (res && res.code === 0) {
          this.$message.success(res.msg)
          if (this.pathData.length === 1 && this.page.pageNo > 1) {
            this.page.pageNo -= 1
          }
          this.getRoamTraceList()
        }
      })
    },
    // 路径保存
    async submitPathForm() {
      // code === name
      this.pathForm.code = this.pathForm.name
      this.pathForm.siteId = this.currentProject.id
      if (this.pathTitle === '新增路径') {
        const res = await roamTrace.saveRoamTrace(this.pathForm)
        if (res && res.code === 0 && res.data) {
          this.cancelPath()
          this.pathForm = this.$options.data().pathForm
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      } else if (this.pathTitle === '编辑路径') {
        const res = await roamTrace.modifyRoamTrace(this.pathForm)
        if (res && res.code === 0 && res.data) {
          this.cancelPath()
          this.pathForm = this.$options.data().pathForm
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      }
      this.getRoamTraceList()
    },
    /**
     * 路径点相关
     */
    // 获取路径点信息
    async getRoamTraceDetail() {
      const query = {
        pagesize: 9999,
        pageno: 1,
        roam_trace_id: this.currentTraceId,
      }
      this.currentParamList = []
      const res = await roamTrace.getRoamTraceDetail(query)
      if (res && res.code === 0 && res.data) {
        const resList = _.sortBy(res.data, ['seq'])
        _.forEach(resList, (item) => {
          this.currentParamList.push({
            detail: JSON.parse(item.locationDetail),
            eye: JSON.parse(item.location),
          })
        })
      }
    },
    pointCell(row, column, cell, event) {
      if (column.label !== '操作') {
        // 移动相机
        this.$emit('moveCameraByVector', JSON.stringify(row))
      }
    },
    // 删除路径点
    deletePoint(index, rows) {
      this.$confirm('是否确定删除?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        rows.splice(index, 1)
      })
    },
    // 修改路径点
    modifyPoint(index, rows) {
      this.$confirm('是否确定修改为当前位置?', '修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await this.getCameraInfo()
        this.$set(rows, index, this.currentParam)
      })
    },
    // 插入一行
    async insertPoint(index, rows) {
      await this.getCameraInfo()
      if (this.currentParam) {
        const addObj = {
          detail: this.currentParam,
          eye: this.currentParam.eye,
        }
        this.currentParamList.splice(index + 1, 0, addObj)
        console.log(this.currentParamList)
      }
    },
    // 下移
    adjustPoint(index, targetIndex, rows) {
      const temp = rows[targetIndex]
      this.$set(rows, targetIndex, rows[index])
      this.$set(rows, index, temp)
    },
    // 保存路径点
    async savePoint(data) {
      // 请求参数
      const params = []
      if (!_.isEmpty(data)) {
        _.forEach(data, (item, index) => {
          const obj = {
            seq: index,
            location: JSON.stringify(item.eye),
            locationDetail: JSON.stringify(item.detail),
            siteId: this.currentProject.id,
          }
          params.push(obj)
        })
      }
      console.log(params)
      const query = {
        roam_trace_id: this.currentTraceId,
        detail: params,
      }
      const res = await roamTrace.updateRoamTraceDetail(query)
      if (res && res.code === 0) {
        this.getRoamTraceList()
        this.getRoamTraceDetail()
        this.$message.success(res.msg)
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style lang="scss" scoped>

#roam_path {
  height: 390px;
  width: 330px;
  left: 8px;
  top: 46px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .path_header {
    margin: 10px 5px 15px 5px;
  }
  .path_table {
    height: calc(100% - 100px);
  }
}
/deep/ .el-table__body-wrapper {
  background-color: transparent !important;
}
#roam_point {
  height: 390px;
  width: 300px;
  right: 8px;
  top: 46px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .point_bottom {
    margin: 5px;
    display: flex;
    justify-content: flex-end;
  }
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-button {
  margin-right: 10px;
}

</style>
